import React, { Component } from "react";
import { Grid, Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { Field, reduxForm } from "redux-form";
import validate from "./validations/forgotPassValidate";
import { renderTextField } from "../../../helpers";
import { withTranslation } from "react-i18next"; // Import withTranslation

const styles = (theme) => ({});

class ForgotPasswordForm extends Component {
    render() {
        const { handleSubmit, t } = this.props; // Destructure t from props

        return (
            <form onSubmit={handleSubmit}>
                <React.Fragment>
                    <Grid container spacing={24} style={{ marginTop: 40, marginBottom: 10 }}>
                        <Grid item xs={12}>
                            <p>
                                {t("forgotPasswordMessage")}{" "}
                                {/* Translate "Моля въведете e-mail адреса, с който сте регистрирани. На него ще получите линк за смяна на парола." */}
                            </p>
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                name="email"
                                fullWidth
                                component={renderTextField}
                                label={t("emailLabel")} /* Translate "E-mail" */
                            />
                        </Grid>
                        <Grid item xs={12} align="right">
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                className="next"
                                align="right"
                            >
                                {t("submitButton")} {/* Translate "Изпрати" */}
                            </Button>
                        </Grid>
                    </Grid>
                </React.Fragment>
            </form>
        );
    }
}

//ForgotPasswordForm.propTypes = {
//    classes: PropTypes.object.isRequired,
//    t: PropTypes.func.isRequired, // Add t to propTypes
//};

export default withStyles(styles)(
    withTranslation()( // Wrap the component with withTranslation
        reduxForm({
            form: "ForgotPasswordForm", // a unique identifier for this form
            destroyOnUnmount: true, // preserve form data
            validate,
            enableReinitialize: true,
        })(ForgotPasswordForm)
    )
);

//import React, { Component } from 'react';
//import { Grid, Button } from '@material-ui/core';
//import withStyles from '@material-ui/core/styles/withStyles';
//import { Field, reduxForm } from 'redux-form';
//import validate from './validations/forgotPassValidate';
//import { renderTextField } from '../../../helpers';

//const styles = theme => ({
//});

//class ForgotPasswordForm extends Component {

//    render() {
//        const { handleSubmit } = this.props;

//        return (
//            <form onSubmit={handleSubmit}>
//                <React.Fragment>
//                    <Grid container spacing={24} style={{ marginTop: 40, marginBottom: 10 }}>
//                        <Grid item xs={12}>
//                            <p>Моля въведете e-mail адреса, с който сте регистрирани. На него ще получите линк за смяна на парола.</p>
//                        </Grid>   
//                        <Grid item xs={12}>
//                            <Field                                
//                                name="email"
//                                fullWidth
//                                component={renderTextField}
//                                label="E-mail"
//                            />
//                        </Grid>                       
//                        <Grid item xs={12} align="right">
//                            <Button
//                                variant="contained"
//                                type="submit"
//                                color="primary"
//                                className="next"
//                                align="right"
//                            >
//                                Изпрати
//                            </Button>
//                        </Grid>
//                    </Grid>
//                </React.Fragment>
//            </form>
//        )
//    }
//}

//export default withStyles(styles)(reduxForm({
//    form: 'ForgotPasswordForm', // a unique identifier for this form
//    destroyOnUnmount: true, // preserve form data
//    validate,
//    enableReinitialize: true
//})(ForgotPasswordForm));